module.exports = __webpack_public_path__ + "static/media/tree-icon-filled.28c6deae.svg";